export default __webpack_public_path__ + "static/media/footprint-info-04.e2dc0b89.svg";